<template>
    <div class="page vendor-add-page">
        <div class="page-header">
            <el-page-header @back="goBack" title="" content="經常性費用"> </el-page-header>
        </div>
        <div class="page-body">
            <div class="page-body-wrapper">
                <div class="panel narrow">
                    <div class="panel-content-wrapper">
                        <div>經常性費用設定</div>
                        <div>{{ form.iteM_NAM }}</div>
                        <div>金額限制</div>
                        <div>{{ form.amT_S }}~{{ form.amT_E }}</div>
                        <div>請款流程</div>
                        <div v-for="(item, index) in form.auditFlowItems.filter(element => element.menU_UNT !== 'ADD')" :key="index">
                            <span>{{ index + 1 }}.</span><span>{{ item.menU_UNT }}</span>
                        </div>
                        <el-button type="primary" round @click="showEditDialog = true">編輯</el-button>
                        <div>
                            資料建立： {{ form.crT_DAT | dateFormater("YYYY-MM-dd") }}
                            {{ form.crT_USR }}
                        </div>
                        <div>
                            最近更新： {{ form.upD_DAT | dateFormater("YYYY-MM-dd") }}
                            {{ form.upD_USR }}
                        </div>
                        <div v-if="topErrorMsg">
                            <el-alert :title="topErrorMsg" type="error" :closable="false" center show-icon> </el-alert>
                            <el-button round type="primary" @click="goBackToList">回經常性費用</el-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <EditDialog v-if="showEditDialog" :visible="showEditDialog" :inputObject="form" @close="closeDialog" />
    </div>
</template>
<script>
import EditDialog from './EditDialog';

export default {
    name: 'CurrentExpendDetailPage',
    components: {
        EditDialog,
    },
    data() {
        return {
            showEditDialog: false,
            topErrorMsg: null,
            form: {},
            errorMsg: '',
        };
    },
    created() {
        this.fetchData();
    },
    methods: {
        goBack() {
            window.history.back();
        },
        fetchData() {
            this.$api({
                url: `/CurrentExpenditureSettingPage/GetSettingDetail?Sno=${this.$route.params.sno}`,
                method: 'GET',
            })
                // 取得成功
                .then((resp) => {
                    // 更新資料
                    this.form = resp.data.setting;

                    if (resp.data.setting.auditFlowItems.length === 0) {
                        this.$api({
                            url: '/CurrentExpenditureSettingPage/GetDefaultAuditFlow',
                            method: 'GET',
                        })
                            // 取得成功
                            .then((resp) => {
                                // 更新資料
                                this.form.auditFlowItems = resp.data.auditFlowItems;
                            });
                    }
                });
        },
        closeDialog(refresh) {
            if (refresh) this.fetchData();

            this.showEditDialog = false;
        },
    },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/vars.scss";

.el-card__header {
    color: red;
}

.contact-card {
    margin-bottom: 40px;
}

// 新增聯絡窗口動畫
.contact-item {
    display: inline-block;
    margin-right: 10px;
}

.contact-enter-active,
.contact-leave-active {
    transition: all 0.8s;
}

.contact-enter,
.contact-leave-to {
    opacity: 0;
    transform: translateY(30px);
}

//
.center-card {
    text-align: center;

    .main-icon {
        font-size: 35pt;
        margin-bottom: 25px;
    }

    .title {
        font-size: 15pt;
        margin-bottom: 20px;
        font-weight: bold;
    }

    .actions {
        margin: 50px 0 0 0;
    }
}
</style>
